const eurFormatter = new Intl.NumberFormat('fr-FR', {
	style: 'currency',
	currency: 'EUR',
	maximumFractionDigits: 2,
});

/**
 * Formate un montant en euros.
 *
 * L'euro et pas le dollar : l'export de facturation Google est déjà converti,
 * et reconvertir était le bug de production QV2-4869. Le symbole reste visible
 * pour qu'aucun montant ne se lise comme une devise qu'il n'est pas.
 *
 * @param value - Montant en EUR, null/undefined traité comme 0
 * @returns Montant formaté, ex. "22,40 €"
 */
export const formatEur = (value?: number | null): string => eurFormatter.format(value || 0);
